import { render, staticRenderFns } from "./UsersAdministration.vue?vue&type=template&id=38614802&scoped=true&"
import script from "./UsersAdministration.vue?vue&type=script&lang=js&"
export * from "./UsersAdministration.vue?vue&type=script&lang=js&"
import style0 from "./UsersAdministration.vue?vue&type=style&index=0&id=38614802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38614802",
  null
  
)

export default component.exports